import React from 'react';

const ActivationSuccessPage = () => {
    return (
      <form className="reg-form table-cell">
        <div className="registration-status success">
          <p className="head--txt">
              Your account is activated. Please use your account credentials to login.
          </p>
        </div>
      </form>
    );
}

export default ActivationSuccessPage;
